import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OnboardingProvider } from './context/OnboardingContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import AccountHome from './pages/AccountHome';
import CreateCharacter from './pages/CreateCharacter';
import Game from './pages/Game';
import GameResults from './pages/GameResults';
import Store from './pages/Store';
import LevelUp from './pages/LevelUp';
import PlacementQuiz from './pages/PlacementQuiz';
import JoinLeague from './pages/JoinLeague';
import { ManagerLogin, ManagerDashboard, LeagueDetail, PlayerCategories, CreateFlashCardSet, ViewFlashCards, ManagerHelp, AcceptManagerInvite } from './pages/Manager';
import {
  AdminLayout,
  Users,
  UserDetail,
  EnhancementTypes,
  EnhancementTester,
  CharacterTypes,
  Categories,
} from './pages/Admin';
import './styles/global.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OnboardingProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/create-character"
            element={
              <ProtectedRoute requireCharacter={false}>
                <CreateCharacter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/placement-quiz"
            element={
              <ProtectedRoute requireCharacter={false}>
                <PlacementQuiz />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game/:categoryId"
            element={
              <ProtectedRoute>
                <Game />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game/results"
            element={
              <ProtectedRoute>
                <GameResults />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store"
            element={
              <ProtectedRoute requireCharacter={false}>
                <Store />
              </ProtectedRoute>
            }
          />
          <Route
            path="/level-up/:characterId"
            element={
              <ProtectedRoute>
                <LevelUp />
              </ProtectedRoute>
            }
          />
          {/* Join League via Invite */}
          <Route path="/join/:token" element={<JoinLeague />} />
          {/* Manager Routes */}
          <Route path="/manager" element={<ManagerLogin />} />
          <Route path="/manager/dashboard" element={<ManagerDashboard />} />
          <Route path="/manager/leagues/:leagueId" element={<LeagueDetail />} />
          <Route path="/manager/leagues/:leagueId/players/:playerId/categories" element={<PlayerCategories />} />
          <Route path="/manager/leagues/:leagueId/flash-card-sets/new" element={<CreateFlashCardSet />} />
          <Route path="/manager/leagues/:leagueId/categories/:categoryId/cards" element={<ViewFlashCards />} />
          <Route path="/manager/help" element={<ManagerHelp />} />
          <Route path="/manager/invite/:token" element={<AcceptManagerInvite />} />
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/users" replace />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:userId" element={<UserDetail />} />
            <Route path="character-types" element={<CharacterTypes />} />
            <Route path="enhancement-types" element={<EnhancementTypes />} />
            <Route path="enhancement-tester" element={<EnhancementTester />} />
            <Route path="categories" element={<Categories />} />
          </Route>
        </Routes>
        </OnboardingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
